// Step labels — used to build the LDSSteps model
export const CREATE_CHAT_STRINGS = {
  title: "Create new chat",
  stepAddParticipants: "Add Participants",
  stepAddGroupDetails: "Add Group Details",
  changeFacilityTitle: "Any participant selections made will be lost if facility is changed. Are you sure you want to proceed?",
  changeFacilityConfirmLabel: "Change Facility",
  rejectedParticipantsWarning: "Chat cannot be initiated with the following participants",
  proceedWithOthers: "Proceed with other participants",
  createChatLabel: "Create chat",
  initialMessageLabel: "What would you like to talk about?",
  initialMessagePlaceholder: "Write your message",
} as const;

type StepState = "initial" | "current" | "complete" | "disabled" | "warning" | "error" | "readOnly";

export function buildCreateChatStepsModel(activeStep: number) {
  return [
    {
      label: CREATE_CHAT_STRINGS.stepAddParticipants,
      state: (activeStep === 0 ? "current" : "complete") as StepState,
    },
    {
      label: CREATE_CHAT_STRINGS.stepAddGroupDetails,
      state: (activeStep === 1 ? "current" : "initial") as StepState,
    },
  ];
}
